import React from 'react';
import { InfoButtonFilled } from '@insurancemenu/imenu-components-lib/dist/icons';
import { colors } from '@insurancemenu/imenu-components-lib/dist/utils';
import { TextStyled, WrapperStyled } from './styles';

interface InfoMessageProps {
  message: string;
}

const InfoMessage: React.FC<InfoMessageProps> = ({ message }) => {
  return (
    <WrapperStyled>
      <InfoButtonFilled width="2rem" height="2rem" color={colors.purple[600]} />
      <TextStyled>{message}</TextStyled>
    </WrapperStyled>
  );
};

export default InfoMessage;
